import React from 'react';
import { useTranslation } from 'react-i18next';

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const { t } = useTranslation();
  const sizes = {
    sm: { width: 'h-8', widthImg: 'w-8', textSize: 'text-lg', subSize: 'text-[10px]' },
    md: { width: 'h-12', widthImg: 'w-12', textSize: 'text-xl', subSize: 'text-[16px]' },
    lg: { width: 'h-16', widthImg: 'w-16', textSize: 'text-2xl', subSize: 'text-[14px]' },
  };

  const { width, widthImg, textSize, subSize } = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="https://vag.org.np/wp-content/uploads/2022/02/LOGO-1.png"
        alt="VAG Logo"
        className={`${width} ${widthImg} object-contain flex-shrink-0`}
      />
      {showText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-bold text-primary-900 ${textSize}`}>
            {t('site.name')}
          </span>
          <span className={`font-medium text-primary-600 ${subSize}`}>
            {t('site.tagline')}
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
